import { useEffect } from 'react';
import { matchPath, useHistory, useLocation } from 'react-router-dom';

import { ROUTES } from '@/common';
import { QueryKeys } from '@/modules/core/hooks';

import { UnappliedFundsTab } from '../UnappliedFunds.types';

export const useClearUnappliedFundsSearchParams = () => {
  const { pathname = '', search = '' } = useLocation();
  const history = useHistory();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const isTabPage = Boolean(matchPath(pathname, { path: ROUTES.UNAPPLIED_FUNDS_ORG_DETAILS(), exact: true }));
    const isUnappliedFundsTab = Object.values<string>(UnappliedFundsTab).includes(query.get(QueryKeys.TAB) ?? '');

    if (!isTabPage && isUnappliedFundsTab) {
      query.delete(QueryKeys.TAB);
      const nextSearch = query.toString();
      history.replace(`${pathname}${nextSearch ? `?${nextSearch}` : ''}`);
    }
  }, [pathname, search, history]);
};
